import React, { Component } from 'react';
import Select from 'react-select';

import './Dropdown.scss';

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
    };
  }

  render() {
    const {
      options,
      onChange,
      placeholder,
      preSelected,
      styles = {},
      initialError,
      errorsRequired,
      ...props
    } = this.props;
    const customStyles = {
      indicatorSeparator: () => ({}),
      control: (provided, { isSelected, isFocused, hasValue }) => {
        return {
          ...provided,
          border:
            isSelected || isFocused
              ? `1px solid ${
                  errorsRequired && initialError
                    ? hasValue
                      ? '#05C3DE'
                      : 'red'
                    : '#05C3DE'
                } !important`
              : `1px solid ${
                  errorsRequired && initialError
                    ? hasValue
                      ? '#bec3c8'
                      : 'red'
                    : '#bec3c8'
                } !important`,
          boxShadow: 'none !important',
          height: '48px',
          borderRadius: '4px',
          ...styles.control,
        };
      },
      menu: (provided) => ({
        ...provided,
        marginTop: '0px',
      }),
      menuList: () => ({
        paddingTop: '8px',
        borderRadius: 'none',
        maxHeight: '173px',
        overflow: 'auto',
      }),
      option: (provided, { isDisabled, isSelected }) => ({
        height: '40px',
        lineHeight: '40px',
        fontSize: '16px',
        paddingLeft: '16px',
        backgroundColor: null,
        fontFamily: isDisabled
          ? 'Nimbus Sans Novus'
          : isSelected
          ? '"Nimbus Sans Novus"'
          : 'Nimbus Sans Novus',

        ':hover': {
          backgroundColor: isDisabled ? null : '#f0f3f5',
        },

        ':active': {
          ...provided[':active'],
          backgroundColor: !isDisabled && '#f0f3f5',
        },
        ...styles.option,
      }),
    };
    return (
      <div className="dropdown-container blocked_data">
        <Select
          aria-label={`dropdown-choice-container`}
          isClearable
          isDisabled={options.length <= 0}
          onChange={onChange}
          options={options}
          placeholder={placeholder}
          styles={customStyles}
          defaultValue={preSelected}
          {...props}
        />
      </div>
    );
  }
}

export default Dropdown;
